import { render, staticRenderFns } from "./OnPageNav.vue?vue&type=template&id=08fc0916&scoped=true&"
import script from "./OnPageNav.vue?vue&type=script&lang=js&"
export * from "./OnPageNav.vue?vue&type=script&lang=js&"
import style0 from "./OnPageNav.vue?vue&type=style&index=0&id=08fc0916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc0916",
  null
  
)

export default component.exports